/**
 * Formats a date filter label by capitalizing the prefix and lowercasing the date key
 * @param {Function} languageContext - Language context function
 * @param {string} prefixKey - Language key for the prefix (e.g., "after", "before")
 * @param {string} dateKey - Language key for the date type (e.g., "startDate", "endDate")
 * @returns {string} Formatted label string
 */
export const formatDateLabel = (languageContext, prefixKey, dateKey) => {
  const prefix = languageContext(prefixKey);
  const date = languageContext(dateKey);
  return `${prefix.charAt(0).toUpperCase()}${prefix.slice(1)} ${date.toLowerCase()}`;
};
